<template>
    <section class="section pl-3 padding">
    <div class="name">nelson omondi odhiambo<i class="fas fa-chess-knight"></i></div>
    <link
    rel="stylesheet"
    href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
  />
 
    <div class="bit-big">&nbsp;<b>Full stack developer</b></div>
    <br>
    <div class="">
        <a href="tel:+254 779 477 821"> +254 779 477 821</a>&#9742;<br>
        <a href="tel:+254 741 192 882">+254 741 192 882</a>&#128222;;
    </div>
    <div class="">
    
        &nbsp;<a href="mailto: nelsonomondi99@gmail.com"> nelsonomondi99@gmail.com</a>&#128231;
       </div>
    
    <div class=""><p>&nbsp;&nbsp;<a href="https://lichess.org/@/AtitoHermes">lichess</a> &#9821; &nbsp; &nbsp; &nbsp;  &nbsp;    
        &nbsp;<a href="https://www.chess.com/member/kenyangippsy">chess.com</a>  &#9823;</P></div>
            </section>
        
    </template>

    
    <script>

    export default {
    name: 'NameComponent',
    }
    </script>
    <style>
    .padding{
        padding-left: 5%;
    }
    .name{
        font-size: 270%;
        font-family: cursive;
        box-shadow: 2px;
        border: 1px;
        color: rgb(121, 76, 10);
        margin: 10%;
        gap: 12%;
        text-align: center;
        text-transform: uppercase;
        text-shadow: 7%;
    }
    .bit-big{
        
        font-size: x-large;
    }
    </style>